// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4951":"0319e70bbde4e547","9553":"d8f1f07e18dbd62d"}[chunkId] + ".css";
};